import React, { useEffect, useState } from "react";
import { api } from "@/lib/config";
import { Save, Calendar, Check } from "lucide-react";

const HELP = `Comment obtenir le code iframe Google Calendar :
1. Allez dans Google Calendar → Paramètres → "Rendez-vous"
2. Choisissez la page de réservation à intégrer
3. Cliquez sur "Partager" → "Intégrer"
4. Copiez l'URL src (entre les guillemets src="...") ou tout le bloc <iframe>
5. Collez ici. La page Contact se mettra à jour automatiquement.`;

function extractSrc(input) {
  if (!input) return "";
  const trimmed = input.trim();
  const match = trimmed.match(/src=["']([^"']+)["']/i);
  return match ? match[1] : trimmed;
}

export default function AdminSettings() {
  const [iframe, setIframe] = useState("");
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get("/settings/gcal_iframe")
      .then(({ data }) => { setIframe(data.value || ""); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const onSave = async () => {
    setErr(""); setSaved(false);
    try {
      const value = extractSrc(iframe);
      await api.put("/admin/settings/gcal_iframe", { value });
      setIframe(value);
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (e) {
      setErr(e.response?.data?.detail || "Erreur");
    }
  };

  return (
    <div data-testid="admin-settings">
      <p className="section-num">Réglages</p>
      <h1 className="display text-4xl mt-3">Configuration du site</h1>

      <div className="mt-12 bg-paper border border-ink/10 p-8 max-w-3xl">
        <div className="flex items-center gap-3 mb-6">
          <Calendar size={20} className="text-brand"/>
          <h2 className="display text-2xl">Google Calendar — Page de prise de rendez-vous</h2>
        </div>

        {loading ? (
          <p className="text-ink/60">Chargement…</p>
        ) : (
          <>
            <p className="text-[13px] text-ink/75 leading-relaxed whitespace-pre-line mb-4">
              {HELP}
            </p>

            <label className="text-xs uppercase tracking-wider text-ink/70">
              URL ou bloc &lt;iframe&gt; complet
            </label>
            <textarea
              data-testid="settings-iframe-input"
              value={iframe}
              onChange={(e) => setIframe(e.target.value)}
              rows={6}
              className="field font-mono text-[12px] mt-2"
              placeholder='https://calendar.google.com/calendar/appointments/...   ou   <iframe src="..." />'
            />

            {iframe && (
              <div className="mt-5">
                <p className="text-[11px] uppercase tracking-wider text-ink/70 mb-2">Aperçu</p>
                <div className="border border-ink/10 bg-paper-2 overflow-hidden">
                  <iframe
                    src={extractSrc(iframe)}
                    title="Aperçu calendrier"
                    width="100%"
                    height="380"
                    style={{ border: 0 }}
                    data-testid="settings-iframe-preview"
                  />
                </div>
              </div>
            )}

            <div className="flex items-center gap-4 mt-6 pt-6 border-t border-ink/10">
              <button onClick={onSave} className="btn-pill btn-primary" data-testid="settings-save">
                <Save size={16}/> Enregistrer
              </button>
              {saved && (
                <span className="inline-flex items-center gap-1.5 text-accent-lime text-sm">
                  <Check size={14}/> Enregistré
                </span>
              )}
              {err && <span className="text-accent-pink text-sm">{err}</span>}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
